'use client'

import { useRef } from 'react'
import ListingWithFilters from './ListingWithFilters'
import { strings } from '@/utils/I18n'

export default function Listing(props) {

  const listing = useRef()
  
  return <ListingWithFilters ref={listing} {...props} withSearch={true} searchPlaceholder={strings(props.site)['global_srpSearchPh']}></ListingWithFilters>
  
}